// const LeftArrow = ({ color = "#8B909A", size = 20, className = "" }) => {
//   return (
//     <div>
//       <svg
//         width={size}
//         height={size}
//         viewBox="0 0 18 18"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//         className={`${className}`}
//       >
//         <g>
//           <g>
//             <path
//               d="M388.419,475.59L168.834,256.005L388.418,36.421c8.341-8.341,8.341-21.824,0-30.165s-21.824-8.341-30.165,0
// 			L123.586,240.923c-8.341,8.341-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251
// 			c5.461,0,10.923-2.091,15.083-6.251C396.76,497.414,396.76,483.931,388.419,475.59z"
//             fill="currentColor"
//             />
//           </g>
//         </g>
//       </svg>
//     </div>
//   )
// }

// export default LeftArrow

const LeftArrow = ({ color = "#8B909A", size = 16, className = "" }) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M12.5 15.5L4.5 9L12.5 2.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };

export default LeftArrow;